<template>
  <div class="p-dashboards">
    <div class="c-grid">
      <div class="c-grid__items">
        <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__9">
          <section v-if="!isRettyPlan" class="p-box">
            <header class="p-box__header">
              <h3 class="p-box__title">
                {{ $t('pages.CompaniesDashboards.todoList.title') }}
              </h3>
            </header>
            <KkLoading v-if="companiesGmbStoresLoading || skippedTodoLoading || userActivityLoading" />
            <div v-else class="p-box__body">
              <ul v-if="hasTodoList">
                <!-- 初回連携 -->
                <li v-if="providedFeaturesPhoto">
                  <div
                    v-if="neverReadPhotos"
                    class="c-info c-info--primary guideForBeginner"
                  >
                    <div class="c-info__icon"><Icon name="iconVector" /></div>
                    <div class="c-info__content">
                      <p>
                        {{ $t('pages.CompaniesDashboards.todoList.neverReadPhotos') }}
                      </p>
                      <router-link
                        :to="{ name: 'CompaniesPhotos', params: { company_uuid: $route.params.company_uuid }}"
                        v-text="$t('labels.check')"
                      />
                    </div>
                  </div>
                </li>
                <li v-if="providedFeaturesReview">
                  <div
                    v-if="neverReadReviews"
                    class="c-info c-info--primary guideForBeginner"
                  >
                    <div class="c-info__icon"><Icon name="iconVector" /></div>
                    <div class="c-info__content">
                      <p>
                        {{ $t('pages.CompaniesDashboards.todoList.neverReadReviews') }}
                      </p>
                      <router-link
                        :to="{ name: 'CompaniesReviews', params: { company_uuid: $route.params.company_uuid }}"
                        v-text="$t('labels.check')"
                      />
                    </div>
                  </div>
                </li>
                <li v-if="providedFeaturesAnalysisReview">
                  <div
                    v-if="neverAnalysisReviews"
                    class="c-info c-info--primary guideForBeginner"
                  >
                    <div class="c-info__icon"><Icon name="iconVector" /></div>
                    <div class="c-info__content">
                      <p>
                        {{ $t('pages.CompaniesDashboards.todoList.neverAnalysisReviews') }}
                      </p>
                      <router-link
                        :to="{ name: 'CompaniesAnalysisReviews', params: { company_uuid: $route.params.company_uuid }}"
                        v-text="$t('labels.check')"
                      />
                    </div>
                  </div>
                </li>
                <!-- 設定や機能操作促し -->
                <li v-if="displaySetupFoodMenuTodo">
                  <KkInfo alert icon="iconSetting" class="todo todo__info">
                    <div class="c-info__content todo__info__content">
                      {{ $t('pages.CompaniesDashboards.todoList.setupFoodMenu') }}
                      <router-link
                        :to="{ name: 'CompaniesFoodMenusIndex', params: { company_uuid: $route.params.company_uuid }}"
                        v-text="$t('labels.check')"
                      />
                      <span
                        class="todo__info__content__notSetup"
                        @click="handleSkipTodo('setupFoodMenu')"
                        v-text="$t('labels.notSetup')"
                      />
                    </div>
                  </KkInfo>
                </li>
                <li v-if="displaySetupServicePatternTodo">
                  <KkInfo alert icon="iconSetting" class="todo todo__info">
                    <div class="c-info__content todo__info__content">
                      {{ $t('pages.CompaniesDashboards.todoList.setupServicePattern') }}
                      <router-link
                        :to="{ name: 'CompaniesServices', params: { company_uuid: $route.params.company_uuid }}"
                        v-text="$t('labels.check')"
                      />
                      <span
                        class="todo__info__content__notSetup"
                        @click="handleSkipTodo('setupServicePattern')"
                        v-text="$t('labels.notSetup')"
                      />
                    </div>
                  </KkInfo>
                </li>
                <li v-if="displaySetupSurveyTodo">
                  <KkInfo alert icon="iconSetting" class="todo todo__info">
                    <div class="c-info__content todo__info__content">
                      {{ $t('pages.CompaniesDashboards.todoList.setupSurvey') }}
                      <router-link
                        :to="{ name: 'CompaniesSurveys', params: { company_uuid: $route.params.company_uuid }}"
                        v-text="$t('labels.check')"
                      />
                      <span
                        class="todo__info__content__notSetup"
                        @click="handleSkipTodo('setupSurvey')"
                        v-text="$t('labels.notSetup')"
                      />
                    </div>
                  </KkInfo>
                </li>
                <li v-if="displaySetupPostTodo">
                  <KkInfo alert icon="iconSetting" class="todo todo__info">
                    <div class="c-info__content todo__info__content">
                      {{ $t('pages.CompaniesDashboards.todoList.setupPost') }}
                      <router-link
                        :to="{ name: 'CompaniesStorePostsIndex', params: { company_uuid: $route.params.company_uuid }}"
                        v-text="$t('labels.check')"
                      />
                      <span
                        class="todo__info__content__notSetup"
                        @click="handleSkipTodo('setupPost')"
                        v-text="$t('labels.notSetup')"
                      />
                    </div>
                  </KkInfo>
                </li>
                <li v-if="displaySetupMediaLibraryTodo">
                  <KkInfo alert icon="info" class="todo todo__info">
                    <div class="c-info__content todo__info__content">
                      {{ $t('pages.CompaniesDashboards.todoList.setupMediaLibrary') }}
                      <router-link
                        :to="{ name: 'CompaniesMediaLibraries', params: { company_uuid: $route.params.company_uuid }}"
                        v-text="$t('labels.check')"
                      />
                      <span
                        class="todo__info__content__notSetup"
                        @click="handleSkipTodo('setupMediaLibrary')"
                        v-text="$t('labels.notSetup')"
                      />
                    </div>
                  </KkInfo>
                </li>
                <template v-if="showMoreThanEditorAuthority">
                  <li v-for="tagGroup in originalTagGroupsUnregisteredByStores" :key="`tagGroup-${tagGroup.kind}`">
                    <KkInfo alert icon="info" class="todo todo__info">
                      <div class="c-info__content todo__info__content">
                        {{ $t('pages.CompaniesDashboards.todoList.originalTagGroupsUnregisteredByStores', { tagGroupName: tagGroup.name, storeCount: tagGroup.unregistered_store_count }) }}
                        <router-link
                          :to="{ name: 'CompaniesLocationStores', params: { company_uuid: $route.params.company_uuid }, query: { filterKey: 'original_tag_group_' + tagGroup.kind, filterValue: -1 }}"
                          v-text="$t('labels.check')"
                        />
                      </div>
                    </KkInfo>
                  </li>
                </template>
                <!-- 未読 -->
                <li v-if="providedFeaturesReview">
                  <div
                    v-if="unreadReviewsCount > 0"
                    class="c-info c-info--primary"
                  >
                    <div class="c-info__icon"><Icon name="iconExclamation" /></div>
                    <div class="c-info__content">
                      <p>
                        {{ $t('pages.CompaniesDashboards.todoList.unreadReviews', { number: unreadReviewsCount.toLocaleString() }) }}
                      </p>
                      <router-link
                        :to="{ name: 'CompaniesReviews', params: { company_uuid: $route.params.company_uuid }}"
                        v-text="$t('labels.check')"
                      />
                    </div>
                  </div>
                </li>
                <li v-if="providedFeaturesPhoto">
                  <div
                    v-if="unreadPhotosCount > 0"
                    class="c-info c-info--primary"
                  >
                    <div class="c-info__icon"><Icon name="iconExclamation" /></div>
                    <div class="c-info__content">
                      <p>
                        {{ $t('pages.CompaniesDashboards.todoList.unreadPhotos', { number: unreadPhotosCount.toLocaleString() }) }}
                      </p>
                      <router-link
                        :to="{ name: 'CompaniesPhotos', params: { company_uuid: $route.params.company_uuid }}"
                        v-text="$t('labels.check')"
                      />
                    </div>
                  </div>
                </li>
                <li v-if="providedFeaturesSurvey">
                  <div
                    v-if="unreadSurveyAnswersCount > 0"
                    class="c-info c-info--primary"
                  >
                    <div class="c-info__icon"><Icon name="iconExclamation" /></div>
                    <div class="c-info__content">
                      <p>
                        {{ $t('pages.CompaniesDashboards.todoList.unreadSurveyAnswers', { number: unreadSurveyAnswersCount.toLocaleString() }) }}
                      </p>
                      <router-link
                        :to="{ name: 'CompaniesCustomSurveyAnswers', params: { company_uuid: $route.params.company_uuid }}"
                        v-text="$t('labels.check')"
                      />
                    </div>
                  </div>
                </li>
                <li v-if="rpaErrorCount > 0">
                  <div class="c-info c-info--primary">
                    <div class="c-info__icon"><Icon name="iconExclamation" /></div>
                    <div class="c-info__content">
                      <p>
                        {{ $t('pages.CompaniesDashboards.todoList.rpaErrorCount', { number: rpaErrorCount }) }}
                      </p>
                      <router-link
                        :to="{ name: 'CompaniesRpaErrorLogs', params: { company_uuid: $route.params.company_uuid }}"
                        v-text="$t('labels.check')"
                      />
                    </div>
                  </div>
                </li>
                <li v-if="reviewReplyErrorCount > 0">
                  <div class="c-info c-info--primary">
                    <div class="c-info__icon"><Icon name="iconExclamation" /></div>
                    <div class="c-info__content">
                      <p>
                        {{ $t('pages.CompaniesDashboards.todoList.reviewReplyErrorCount', { number: reviewReplyErrorCount }) }}
                      </p>
                      <router-link
                        :to="{ name: 'CompaniesReviews', params: { company_uuid: $route.params.company_uuid }, query: { replies: 'error' }}"
                        v-text="$t('labels.check')"
                      />
                    </div>
                  </div>
                </li>
                <!-- <li>
                  <div
                    v-if="unreadGmbLocationSyncLogsCount > 0"
                    class="c-info c-info--primary"
                  >
                    <div class="c-info__icon"><Icon name="iconExclamation" /></div>
                    <div class="c-info__content">
                      <p>
                        {{ $t('pages.CompaniesDashboards.todoList.unreadGmbLocationSyncLogsCount', { number: unreadGmbLocationSyncLogsCount }) }}
                      </p>
                      <router-link
                        :to="{ name: 'CompaniesGMBLocationSyncLogs', params: { company_uuid: $route.params.company_uuid }}"
                        v-text="$t('labels.check')"
                      />
                    </div>
                  </div>
                </li> -->
              </ul>
              <p v-else>{{ $t('pages.CompaniesDashboards.todoList.noData') }}</p>
            </div>
          </section>

          <!-- 特典 -->
          <KkRecommendedBenefits
            v-if="displayRecommendedBenefits"
            :benefits="benefits"
            :loading="benefitsLoading"
          />

          <section v-if="providedFeaturesAnalysisReview" class="p-box">
            <header class="p-box__header">
              <h3 class="p-box__title">
                {{ $t('pages.CompaniesDashboards.analysisReviewSummaries.title') }}
              </h3>
            </header>
            <div class="p-box__body">
              <KkLoading v-show="analysis_review_summaries_loading" />
              <div v-if="analysis_review_summaries" class="c-grid">
                <div class="c-grid__items">
                  <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
                    <div class="p-dashboards__graphLegend">
                      <span
                        v-for="i in [5,4,3,2,1]"
                        :key="i"
                        :class="`rating${i}`"
                        v-text="$t('labels.rating', {value: i})"
                      />
                      <span
                        class="rating_unrated"
                        v-text="$t('labels.unrated')"
                      />
                    </div>
                  </div>
                  <div
                    v-for="( summary, i ) in analysis_review_summaries.data"
                    :key="i"
                    class="c-grid__item c-grid__item__s__12 c-grid__item__m__6 c-grid__item__l__6"
                  >
                    <div class="p-dashboards__graphArea">
                      <p class="p-dashboards__graphArea__title">
                        {{ $t('pages.CompaniesDashboards.analysisReviewSummaries.graphTitle', {days: summary.attributes.term_days}) }}
                      </p>
                      <div class="p-dashboards__graphArea__content">
                        <p v-if="summary.attributes.total_count === 0" class="noData">
                          <Icon name="iconGraphDoughnutNoData" />
                          <span v-text="$t('messages.noData')" />
                        </p>
                        <ChartDoughnut
                          v-if="summary.attributes.total_count > 0"
                          :chart-data="dataForChartDoughnut(summary.attributes)" :options="optionsForChartDoughnut"
                          :text="summary.attributes.total_count > 0 && summary.attributes.total_count + $t('pages.CompaniesDashboards.analysisReviewSummaries.unit')"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section v-if="providedFeaturesReview" class="p-box">
            <header class="p-box__header">
              <h3 class="p-box__title">
                {{ $t('pages.CompaniesDashboards.reviews.title') }}
              </h3>
            </header>
            <div class="p-box__body">
              <KkLoading v-show="reviews_loading" />
              <template v-if="reviews">
                <div v-if="reviews.data.length" class="p-reviews">
                  <div
                    v-for="( review, i ) in reviews.data"
                    :key="i"
                    class="p-reviews__item"
                  >
                    <div class="p-reviews__header">
                      <p class="p-reviews__name">{{ review.attributes.store_name }}</p>
                    </div>
                    <div class="p-reviews__summary">
                      <div class="p-reviews__site">
                        <div class="p-reviews__site__icon">
                          <KkSiteIcon :name="review.attributes.site_type" />
                        </div>
                        <div class="p-reviews__site__name">{{ review.attributes.site_name }}</div>
                      </div>
                      <div class="p-reviews__reviewRating">
                        <div class="c-rating">
                          <div class="c-rating__number">{{ review.attributes.rating }}</div>
                          <div class="c-rating__stars">
                            <Star :rating="review.attributes.rating" />
                          </div>
                        </div>
                      </div>
                      <div class="p-reviews__postedDate">
                        {{ basicDateFormat(review.attributes.posted_at) }}
                      </div>
                      <div class="p-reviews__reviewer">
                        {{ review.attributes.reviewer_name }}
                      </div>
                    </div>
                    <div class="p-reviews__content">
                      <div class="p-reviews__title">{{ review.attributes.title }}</div>
                      <div class="p-reviews__comment">
                        <div class="p-dashboards__truncatedText">
                          {{ review.attributes.comment }}
                        </div>
                      </div>
                      <div class="p-reviews__source">
                        {{ $t('labels.source') }}
                        <a
                          :href="review.attributes.site_url"
                          target="_blank"
                        >
                          {{ review.attributes.site_name }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <p v-else>{{ $t('messages.noData') }}</p>
                <div class="c-button c-button--right">
                  <router-link
                    :to="{ name: 'CompaniesReviews', params: { company_uuid: $route.params.company_uuid }}"
                    class="c-button__item c-button__item--primary"
                    v-text="$t('labels.viewDetail')"
                  />
                </div>
              </template>
            </div>
          </section>

          <section v-if="isDocomoPlan" class="p-box">
            <header class="p-box__header">
              <h3 class="p-box__title">
                {{ $t('pages.CompaniesDashboards.usefulInfo.title') }}
              </h3>
            </header>
            <div class="p-box__body">
              <div class="usefulInfo">
                <a class="usefulInfo__content" target="_blank" href="https://service.smt.docomo.ne.jp/keitai_payment/corporation/shop/tips.html">
                  <KkIcon name="dPayBanner1" class="usefulInfo__image" />
                  <div class="usefulInfo__text">
                    {{ $t('pages.CompaniesDashboards.usefulInfo.content1') }}
                  </div>
                </a>
                <a class="usefulInfo__content" target="_blank" href="https://nttdocomo-ssw.com/keitai_payment/campaign/dpay_ouen/index.html">
                  <KkIcon name="dPayBanner2" class="usefulInfo__image" />
                  <div class="usefulInfo__text">
                    {{ $t('pages.CompaniesDashboards.usefulInfo.content2') }}
                  </div>
                </a>
              </div>
            </div>
          </section>

          <section v-if="isDocomoPlan" class="p-box">
            <header class="p-box__header">
              <h3 class="p-box__title">
                {{ $t('pages.CompaniesDashboards.docomoAcademy.title') }}
              </h3>
            </header>
            <div class="p-box__body">
              <div class="docomoAcademy">
                <a class="docomoAcademy__content" target="_blank" href="https://academy.kutikomi.com/curriculums/dbarai/">
                  <KkIcon name="dPayAcademyBanner" class="docomoAcademy__image" />
                  <div class="docomoAcademy__text">
                    {{ $t('pages.CompaniesDashboards.docomoAcademy.content1') }}
                  </div>
                </a>
                <a class="docomoAcademy__content" target="_blank" href="https://academy.kutikomi.com/curriculums/dpoint/">
                  <KkIcon name="dPointAcademyBanner" class="docomoAcademy__image" />
                  <div class="docomoAcademy__text">
                    {{ $t('pages.CompaniesDashboards.docomoAcademy.content2') }}
                  </div>
                </a>
              </div>
            </div>
          </section>
        </div>

        <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__3">
          <InitialSettingGuideLinkButton v-if="showOnlyOwnerAuthority && providedFeaturesInitialSettingGuide && showInitialSettingGuide && !isRettyPlan" :count="unconfirmedCount" />
          <section v-if="providedFeaturesNotification && !isRettyPlan" class="p-box">
            <header class="p-box__header">
              <h3 class="p-box__title p-box__title--narrowWidth">
                {{ $t('pages.CompaniesDashboards.notifications.title') }}
              </h3>
            </header>
            <div class="p-box__body p-box__body--narrowWidth">
              <KkLoading v-show="notifications_loading" />
              <template v-if="notifications">
                <div v-if="notifications.data.length">
                  <ul>
                    <li
                      v-for="( notification, i ) in notifications.data"
                      :key="i"
                      class="c-infoB"
                    >
                      <div class="c-infoB__content">
                        <p>{{ basicDateFormat(notification.attributes.created_at) }}</p>
                        <div
                          v-if="notification.attributes.important"
                          class="c-infoB__icon"
                        >
                          <img :src="iconExclamationBPath">
                        </div>
                        <router-link :to="{ name: 'CompaniesNotification', params: { company_uuid: $route.params.company_uuid, id: notification.id }}">
                          <span v-if="notification.attributes.category_name">
                            【{{ notification.attributes.category_name }}】
                          </span>
                          {{ notification.attributes.title }}
                        </router-link>
                      </div>
                    </li>
                  </ul>
                </div>
                <p v-else>{{ $t('messages.noData') }}</p>
              </template>
            </div>
            <footer class="p-box__footer u-taR">
              <router-link :to="{ name: 'CompaniesNotifications', params: { company_uuid: $route.params.company_uuid }}" class="u-colorPrimary">
                {{ $t('labels.viewMore') }}
              </router-link>
            </footer>
          </section>

          <a v-if="!isDocomoPlan && !isRettyPlan" target="_blank" :href="academyUrl"><img :src="academyBannerImg" alt="" class="academyBanner"></a>

          <section class="p-box">
            <header class="p-box__header">
              <h3 class="p-box__title p-box__title--narrowWidth">
                {{ $t('pages.CompaniesDashboards.articles.title') }}
              </h3>
            </header>
            <div class="p-box__body p-box__body--narrowWidth">
              <KkLoading v-show="articles_loading" />
              <template v-if="articles">
                <div v-if="articles.data.length">
                  <ul>
                    <li
                      v-for="( article, i ) in articles.data"
                      :key="i"
                      class="c-infoC"
                    >
                      <div class="c-infoC__eyeCatch"> <img alt="" :src="article.img_src"> </div>
                      <div class="c-infoC__content"><a :href="article.link" target="_blank">{{ article.title }}</a> </div>
                    </li>
                  </ul>
                </div>
                <p v-else>{{ $t('messages.noData') }}</p>
              </template>
            </div>
            <footer class="p-box__footer u-taR">
              <a class="u-colorPrimary" href="https://lab.kutikomi.com?utm_source=rss" target="_blank">
                {{ $t('labels.viewMore') }}
              </a>
            </footer>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { mapState as piniaMapState, mapActions as piniaMapActions } from 'pinia'
import moment from 'moment'
import Star from '../components/Star.vue'
import ChartDoughnut from '../components/ChartDoughnut.vue'
import iconExclamationBPath from '../../../images/common/icon_exclamationB.svg'
import academyBannerImg from '../../../images/dashboards/academyBanner.png'
import Icon from '../components/Icon.vue'
import { KkLoading, KkIcon } from '../components/base'
import { KkInfo } from '../components/ui'
import { KkSiteIcon } from '../components/base'
import InitialSettingGuideLinkButton from '../components/CompaniesDashboards/InitialSettingGuideLinkButton'
import { KkRecommendedBenefits } from '../domains/home'
import { useBenefitsStore } from '../new_stores/pages/benefits/modules'

export default {
  name: 'CompaniesDashboards',
  components: {
    InitialSettingGuideLinkButton,
    KkLoading,
    Star,
    KkSiteIcon,
    ChartDoughnut,
    Icon,
    KkInfo,
    KkIcon,
    KkRecommendedBenefits,
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if(vm.providedFeaturesInitialSettingGuide && vm.showOnlyOwnerAuthority) vm.readInitialSettingGuideConfirmations()
    })
  },
  data: function() {
    return {
      iconExclamationBPath,
      academyBannerImg,
      academyUrl: 'https://academy.kutikomi.com/?utm_source=kutikomicom&utm_medium=referral&utm_campaign=2212_kcom2kaca_banner'
    }
  },
  computed: {
    ...mapState({
      analysis_review_summaries: state => state.companiesDashboardAnalysisReviewSummaries.data,
      reviews: state => state.companiesDashboardReviews.data,
      notifications: state => state.companiesDashboardNotifications.data,
      articles: state => state.companiesArticles.data,
      analysis_review_summaries_loading: state => state.companiesDashboardAnalysisReviewSummaries.loading,
      reviews_loading: state => state.companiesDashboardReviews.loading,
      notifications_loading: state => state.companiesDashboardNotifications.loading,
      articles_loading: state => state.companiesArticles.loading,
      userActivity: state => state.companiesUserActivity.data,
      userActivityLoading: state => state.companiesUserActivity.loading,
      companiesGmbStoresLoading: state => state.companiesGmbStores.loading,
      skippedTodo: state => state.companiesSkippedTodos.data,
      skippedTodoLoading: state => state.companiesSkippedTodos.loading,
    }),
    ...piniaMapState(
      useBenefitsStore, ['benefits', 'benefitsLoading']
    ),
    ...mapGetters({
      unreadReviewsCount: 'companiesUserActivity/unreadReviewsCount',
      unreadPhotosCount: 'companiesUserActivity/unreadPhotosCount',
      unreadSurveyAnswersCount: 'companiesUserActivity/unreadSurveyAnswersCount',
      unreadGmbLocationSyncLogsCount: 'companiesUserActivity/unreadGmbLocationSyncLogsCount',
      originalTagGroupsUnregisteredByStores: 'companiesUserActivity/originalTagGroupsUnregisteredByStores',
      neverReadPhotos: 'companiesUserActivity/neverReadPhotos',
      neverReadReviews: 'companiesUserActivity/neverReadReviews',
      neverAnalysisReviews: 'companiesUserActivity/neverAnalysisReviews',
      hasServicePattern: 'companiesUserActivity/hasServicePattern',
      hasFoodMenu: 'companiesUserActivity/hasFoodMenu',
      hasPublishingSurvey: 'companiesUserActivity/hasPublishingSurvey',
      hasPublishedPosts: 'companiesUserActivity/hasPublishedPosts',
      hasCompleteMediaLibrary: 'companiesUserActivity/hasCompleteMediaLibrary',
      rpaErrorCount: 'companiesUserActivity/rpaErrorCount',
      reviewReplyErrorCount: 'companiesUserActivity/reviewReplyErrorCount',
      unconfirmedCount: 'companiesInitialSetupGuides/unconfirmedCount',
      showInitialSettingGuide: 'companiesInitialSetupGuides/showInitialSettingGuide',
      providedFeaturesPhoto: 'companiesCompany/providedFeaturesPhoto',
      providedFeaturesReview: 'companiesCompany/providedFeaturesReview',
      providedFeaturesAnalysisReview: 'companiesCompany/providedFeaturesAnalysisReview',
      providedFeaturesSurvey: 'companiesCompany/providedFeaturesSurvey',
      providedFeaturesFoodMenu: 'companiesCompany/providedFeaturesFoodMenu',
      providedFeaturesServicePattern: 'companiesCompany/providedFeaturesServicePattern',
      providedFeaturesInitialSettingGuide: 'companiesCompany/providedFeaturesInitialSettingGuide',
      providedFeaturesPost: 'companiesCompany/providedFeaturesPost',
      providedFeaturesMediaLibrary: 'companiesCompany/providedFeaturesMediaLibrary',
      providedFeaturesNotification: 'companiesCompany/providedFeaturesNotification',
      providedFeaturesBenefit: 'companiesCompany/providedFeaturesBenefit',
      useServiceName: 'companiesCompany/useServiceName',
      isDocomoPlan: 'companiesCompany/isDocomoPlan',
      isRettyPlan: 'companiesCompany/isRettyPlan',
      canHaveFoodMenus: 'companiesCompany/canHaveFoodMenus',
      canModifyServiceList: 'companiesCompany/canModifyServiceList',
      showOnlyOwnerAuthority: 'companiesAccessibleApi/showOnlyOwnerAuthority',
      showMoreThanEditorAuthority: 'companiesAccessibleApi/showMoreThanEditorAuthority',
      noLinked: 'companiesGmbStores/noLinked',
    }),
    hasTodoList() {
      let availableTagGroups = []
      if (this.showMoreThanEditorAuthority) {
        availableTagGroups = this.originalTagGroupsUnregisteredByStores
      }

      return this.unreadReviewsCount > 0
        || this.unreadPhotosCount > 0
        || this.unreadSurveyAnswersCount > 0
        || this.neverAnalysisReviews
        || this.neverReadPhotos
        || this.neverReadReviews
        || this.rpaErrorCount > 0
        || this.reviewReplyErrorCount > 0
        || this.displaySetupFoodMenuTodo
        || this.displaySetupSurveyTodo
        || this.displaySetupServicePatternTodo
        || this.displaySetupPostTodo
        || this.displaySetupMediaLibraryTodo
        || availableTagGroups.length > 0
        // || this.unreadGmbLocationSyncLogsCount > 0
    },
    displaySetupFoodMenuTodo() {
      if (!this.userActivity) return false
      if (this.skippedTodo?.setupFoodMenuSkipped) return false

      return this.showOnlyOwnerAuthority
        && this.providedFeaturesFoodMenu
        && this.canHaveFoodMenus
        && !this.hasFoodMenu
    },
    displaySetupServicePatternTodo() {
      if (!this.userActivity) return false
      if (this.skippedTodo?.setupServicePatternSkipped) return false

      return this.showOnlyOwnerAuthority
        && this.providedFeaturesServicePattern
        && this.canModifyServiceList
        && !this.hasServicePattern
    },
    displaySetupSurveyTodo() {
      if (!this.userActivity) return false
      if (this.skippedTodo?.setupSurveySkipped) return false

      return this.showOnlyOwnerAuthority
        && this.providedFeaturesSurvey
        && !this.hasPublishingSurvey
    },
    displaySetupPostTodo() {
      if (!this.userActivity) return false
      if (this.skippedTodo?.setupPostSkipped) return false

      return this.showOnlyOwnerAuthority
        && this.providedFeaturesPost
        && !this.hasPublishedPosts
    },
    displaySetupMediaLibraryTodo() {
      if (!this.userActivity) return false
      if (this.skippedTodo?.setupMediaLibrarySkipped) return false

      return this.showOnlyOwnerAuthority
        && this.providedFeaturesMediaLibrary
        && !this.noLinked
        && !this.hasCompleteMediaLibrary
    },
    optionsForChartDoughnut() {
      return {
        responsive: true,
        plugins: {
          legend: {
            display: false
          },
        },
      }
    },
    displayRecommendedBenefits() {
      return this.providedFeaturesBenefit && this.showOnlyOwnerAuthority && this.useServiceName === 'kcom'
    }
  },
  created: function() {
    // TODO: フルSPA化までの暫定実装
    $('a.l-menu__name.menu_item__home').addClass('is-current')

    this.readUserActivity({ companyUuid: this.$route.params.company_uuid })
    if(this.providedFeaturesAnalysisReview) this.readAnalysisReviewSummaries( this.$route.params.company_uuid )
    if(this.providedFeaturesReview) this.readReviews( this.$route.params.company_uuid )
    if(this.providedFeaturesNotification) this.readNotifications(this.$route.params.company_uuid)
    this.readArticles()
    this.readGmbStores(this.$route.params.company_uuid)
    if(this.providedFeaturesInitialSettingGuide && this.showOnlyOwnerAuthority) this.readInitialSettingGuideConfirmations()
    if(this.showOnlyOwnerAuthority) this.readSkippedTodo()
    // おすすめの特典は最新50の中から3つ選んで表示するため、API経由でまず50個取得
    if(this.displayRecommendedBenefits) this.readBenefits({ companyUuid: this.$route.params.company_uuid, params: { per: 50, page: 1 }})
  },
  methods: {
    ...mapActions({
      readAnalysisReviewSummaries: 'companiesDashboardAnalysisReviewSummaries/readAnalysisReviewSummaries',
      readReviews: 'companiesDashboardReviews/readReviews',
      readNotifications: 'companiesDashboardNotifications/readNotifications',
      readArticles: 'companiesArticles/readArticles',
      readInitialSettingGuideConfirmations: 'companiesInitialSetupGuides/readInitialSettingGuideConfirmations',
      readUserActivity: 'companiesUserActivity/readUserActivity',
      readGmbStores: 'companiesGmbStores/readGmbStores',
      readSkippedTodo: 'companiesSkippedTodos/readSkippedTodo',
      skipTodo: 'companiesSkippedTodos/skipTodo',
    }),
    ...piniaMapActions(useBenefitsStore, ['readBenefits']),
    imgGraphLegendPath: function(type) {
      switch( type ) {
      case 'Nps':
        return imgGraphLegendNpsPath
      case 'Qsca':
        return imgGraphLegendQscaPath
      case 'Review':
        return imgGraphLegendReviewPath
      default:
        return ''
      }
    },
    basicDateFormat: function( date ) {
      return date ? moment( date ).format(this.$t('format.date.default')) : ''
    },
    basicDateTimeFormat: function( date ) {
      return date ? moment( date ).format(this.$t('format.datetime.default')) : ''
    },
    roundNumber: function( number, digits ) {
      return (Math.round(number * 100) / 100 ).toFixed(digits)
    },
    operatorString: function( number ) {
      if ( number === 0 ) {
        return '±'
      } else if (number > 0 ) {
        return '+'
      } else {
        return ''
      }
    },
    dataForChartDoughnut: function(attributes) {
      return {
        datasets: [
          {
            data: attributes.values,
            backgroundColor: attributes.colors,
          }
        ],
        labels: attributes.labels
      }
    },
    handleSkipTodo(todoKey) {
      if (!confirm(this.$t('pages.CompaniesDashboards.todoList.confirmToSkipTodo'))) return

      this.skipTodo(todoKey)
    }
  }
}
</script>

<style lang="scss" scoped>
.p-box__body {
  ul {
    li {
      margin-bottom: 10px;
    }
  }
}
.guideForBeginner {
  background: #4A6279;
}
.todo {
  width: 100%;

  &__info {
    padding: 15px 12px;
    background-color: #4A6279 !important;

    &__content {
      margin-left: -4px;
      font-weight: bold;

      a {
        color: #fff;
      }

      &__notSetup {
        margin-left: 8px;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
}
.academyBanner {
  margin-top: 24px;
  @media screen and (max-width: 1440px) {
    width: 100%;
    max-width: 425px;
  }
}

.usefulInfo {
  display: flex;
  justify-content: space-around;
  &__content {
    width: 45%;
    border-radius: 12px;
    padding: 0 0 16px;
  }
  &__image {
    width: 100%;
    vertical-align: top;
  }
  &__text {
    border: solid 1px #E3E3E3;
    border-radius: 0 0 12px 12px;
    padding: 10px 16px 18px
  }
}

.docomoAcademy {
  display: flex;
  justify-content: space-around;
  &__content {
    width: 45%;
    border-radius: 12px;
    padding: 0 0 16px;
  }
  &__image {
    width: 100%;
    vertical-align: top;
  }
  &__text {
    border: solid 1px #E3E3E3;
    border-radius: 0 0 12px 12px;
    padding: 10px 16px 18px
  }
}
</style>
